import Grid from '@material-ui/core/Grid';
// ACCORDION
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

import sub1month from "../assets/redeem/sub1month.png";
// import sub2months from "../assets/redeem/sub2months.png";
import logoBunny from "../assets/redeem/logo-bunny.png";
import { useHomeStyles } from '../styles/home';

interface RewardsProps {
   handleOpen: () => unknown   
}

export const Rewards = (props: RewardsProps) => {
   const { handleOpen } = props;
   const classes = useHomeStyles(); // CUSTOM STYLES FOR PAGE

   return (
      <Grid item xs={12} md={12}>
         {/* accordion item */}
         <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography className={classes.accordionHeading}><b>Redeem Your NFT Perks</b></Typography>
            </AccordionSummary>
            <AccordionDetails>
            {/* <Typography variant="h5" style={{ fontWeight: 'bold' }}>Rewards Available</Typography> */}

            <Grid container spacing={3} style={{ padding: '25px 0' }}>
               {/* ITEM */}
               <Grid item xs={12} md={4}>
               <a href="https://lasvegasvp.com/dark" target="_blank" rel="noreferrer">
                  <Paper className={classes.rewardsBox}>
                     <Grid container alignItems="center" style={{ padding: '10px', flexDirection: 'row' }}>
                     {/* <Grid item xs={2}>
                        <Checkbox inputProps={{ 'aria-label': 'checkBox1' }} style={{color: '#823eed'}}/>
                     </Grid> */}
                     <Grid item xs={2}>
                        <img style={{width: '100%'}} src={logoBunny} alt="After Dark Live" />
                     </Grid>
                     <Grid style={{textAlign: 'center'}} item xs={10}>
                        <Typography variant="caption" style={{color: 'black', fontWeight: 'bold'}}>After Dark Live</Typography>
                        <Typography variant="caption" style={{color: 'black', display: 'block', padding: '0 10px'}}>Tap here to join the private stream.</Typography>
                     </Grid>
                     </Grid>
                  </Paper>
               </a>
               </Grid>
               {/* END ITEM */}
               {/* ITEM */}
               <Grid item xs={12} md={4}>
               <Link component={RouterLink} to="/redeem/archives" style={{ textDecoration: 'none' }}>
                  <Paper className={classes.rewardsBox}>
                     <Grid container alignItems="center" style={{ padding: '10px', flexDirection: 'row' }}>
                     {/* <Grid item xs={2}>
                        <Checkbox defaultChecked inputProps={{ 'aria-label': 'checkBox1' }} style={{color: '#823eed'}}/>
                     </Grid> */}
                     <Grid item xs={2}>
                        <img style={{width: '100%'}} src={sub1month} alt="lifetime subscription" />
                     </Grid>
                     <Grid style={{textAlign: 'center'}} item xs={10}>
                        <Typography variant="caption" style={{color: 'black', fontWeight: 'bold'}}>Video Archives</Typography>
                        <Typography variant="caption" style={{color: 'black', display: 'block', padding: '0 10px'}}>Tap here to access hundreds of videos in the complete archive.</Typography>
                     </Grid>
                     </Grid>
                  </Paper>
               </Link>
               </Grid>
               {/* END ITEM */}
               {/* ITEM */}
               {/* <Grid item xs={12} md={4}>
               <Paper className={classes.checked} style={{display: 'flex', alignItems: 'center', background: 'white', boxShadow: '0px 0px 5px 1px rgb(0 0 0 / 20%)', minHeight: '100px' }}>
                  <Grid container alignItems="center" style={{ padding: '10px', flexDirection: 'row' }}>
                     <Grid item xs={2}>
                     <img style={{width: '100%'}} src={sub1month} alt="lifetime subscription" />
                     </Grid>
                     <Grid style={{textAlign: 'center'}} item xs={10}>
                     <Typography variant="caption" style={{color: 'black', fontWeight: 'bold'}}>Lifetime Subscription</Typography>
                     <Typography variant="caption" style={{color: 'black', display: 'block', padding: '0 10px'}}>Redeem for a Twitch.tv LasVegasVP channel Lifetime subscription</Typography>
                     </Grid>
                  </Grid>
               </Paper>
               </Grid> */}
               {/* END ITEM */}
               {/* ITEM */}
               {/* <Grid item xs={12} md={4}>
               <Paper style={{display: 'flex', alignItems: 'center', background: 'white', boxShadow: '0px 0px 5px 1px rgb(0 0 0 / 20%)', minHeight: '100px' }}>
                  <Grid container alignItems="center" style={{ padding: '10px', flexDirection: 'row'}}>
                     <Grid item xs={2}>
                     <img style={{width: '100%'}} src={sub2months} alt="dine & play experience" />
                     </Grid>
                     <Grid style={{textAlign: 'center'}} item xs={10}>
                     <Typography variant="caption" style={{color: 'black', fontWeight: 'bold'}}>Dine & Play Experience</Typography>
                     <Typography variant="caption" style={{color: 'black', display: 'block', padding: '0 10px'}}>Redeem for a Dine and play experience with VP and/or crew</Typography>
                     </Grid>
                  </Grid>
               </Paper>
               </Grid> */}
               {/* END ITEM */}
               {/* ITEM */}
               <Grid item xs={12} md={4}>
               <Paper 
                  className={classes.rewardsBox}
                  onClick={handleOpen}
               >
                  <Grid container alignItems="center" style={{ padding: '10px', flexDirection: 'row' }}>
                     <Grid item xs={2}>
                     <img style={{width: '100%'}} src={logoBunny} alt="RSVP Event" />
                     </Grid>
                     <Grid style={{textAlign: 'center'}} item xs={10}>
                     <Typography variant="caption" style={{color: 'black', fontWeight: 'bold'}}>RSVP Event</Typography>
                     <Typography variant="caption" style={{color: 'black', display: 'block', padding: '0 10px'}}>Tap here to RSVP yourself for the next in-person meetup event.</Typography>
                     </Grid>
                  </Grid>
               </Paper>
               </Grid>
               {/* END ITEM */}
            </Grid>
            </AccordionDetails>
         </Accordion>  
      </Grid>
   )
}